import { Button, Row } from "@commonlibs";
import styled, { css } from "styled-components";

export const MovementsSection = styled(Row)(
    () => css`
        max-height: 350px;
        padding: 10px 0px;
        border-top: 2px solid #27292b14;
        border-bottom: 1px solid #27292b14;
    `,
);

export const VerticalDivider = styled.div(
    () => css`
        margin-right: 30px;
        height: auto;
        width: 1px;
        background-color: #27292b14;
    `,
);

export const ToolbarButton = styled(Button)(
    () => css`
        width: 220px;
    `,
);
